import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowRight, FiClock } = FiIcons;

function StartScreen({ config, onStart }) {
  return (
    <div className="start-screen">
      <div className="start-copy">
        <span className="section-kicker">Een korte blikopener</span>
        <h1>{config.title}</h1>
        <div className="intro">
          <p className="intro-lead">{config.intro[0]}</p>
          <p>{config.intro[1]}</p>
          <p>{config.intro[2]}</p>
        </div>
        <motion.button
          type="button"
          className="primary-button"
          onClick={onStart}
          whileTap={{ scale: 0.98 }}
        >
          Start de quiz
          <SafeIcon icon={FiArrowRight} aria-hidden="true" />
        </motion.button>
        <span className="duration">
          <SafeIcon icon={FiClock} aria-hidden="true" />
          {config.duration}
        </span>
      </div>
      <div className="start-visual" aria-hidden="true">
        <div className="visual-sun" />
        <div className="visual-window">
          <span>wat blijft</span>
          <strong>mogelijk?</strong>
        </div>
        <div className="visual-wave" />
      </div>
    </div>
  );
}

export default StartScreen;